export const MetricsNames = {
  Activity: 'activity',
  OilTemperature: 'oilTemperature',
  WaterPressureIn: 'waterPressureIn',
  WaterPressureOut: 'waterPressureOut',
  WaterPressureDelta: 'waterPressureDelta',
  Power: 'power',
  HorsePower: 'horsePower',
  RatedPower: 'ratedPower',
  ControlMode: 'controlMode',
  Flow: 'flow',
  Pressure: 'pressure',
  NextServiceIn: 'nextServiceIn',
  NextServiceType: 'nextServiceType',
  InverterSpeed: 'inverterSpeed',
  InletValve: 'inletValve',
  BypassValve: 'bypassValve',
  WorkingHours: 'workingHours',
  DewPoint: 'dewPoint',
  OperationMode: 'operationMode',
  Connectivity: 'connectivity',
  Frequency: 'frequency',
  AirTemperature: 'airTemperature',
  Humidity: 'humidity',
};
